export default __webpack_public_path__ + "static/media/4.07cde683.jpg";